/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Submit/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Submit({
  children,
  viewPath = "/App/Auth/SignIn/Submit",
  isSubmitting,
  onSubmit
  
}) {
let signinSubmitData = fromData.useDataSubmit({ viewPath,
context: 'signin',
})
let signinIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'signin',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 size="large"
 alignSelf="flex-end"
 data="signin"
 disabled={signinIsSubmittingData}
 onClick={signinSubmitData}
 marginTop={dtSpaceM}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Sign In"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}